import React, { Suspense } from 'react'
import { connect } from 'react-redux'
import Loadable from 'react-loadable'
import { Route, Switch } from 'react-router-dom'
import Aux from '../hoc/_Aux'
import Loader from './layout/Loader'
import ScrollToTop from './layout/ScrollToTop'
import * as SettingsActions from '../store/Settings/actionCreators'

const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
})

interface ActionProps {
    getSettings: typeof SettingsActions.actionCreators.getSettings
}

const App: React.FC<ActionProps> = props => {

/*    React.useEffect(() => {
        props.getSettings()
    })*/

    return (
        <Aux>
            <ScrollToTop>
                <Suspense fallback={<Loader/>}>
                    <Switch>
                        <Route path="/" component={AdminLayout}/>
                    </Switch>
                </Suspense>
            </ScrollToTop>
        </Aux>
    )
}

export default connect(null, {
    getSettings: SettingsActions.actionCreators.getSettings
})(App)
